__turbopack_context__.v({
  "className": "jetbrains_mono_14359a50-module__W6N_-q__className",
});
